// extracted by mini-css-extract-plugin
module.exports = {"audioBtn":"ScrollVideo_audioBtn__LdOgj","muteBtn":"ScrollVideo_muteBtn__771Bs","notification":"ScrollVideo_notification__SprDv","reverse":"ScrollVideo_reverse__IJNWG"};